/* app/js/src/components/common/full-screen-icon/full-screen-icon.component.scss */
/*# sourceMappingURL=full-screen-icon.component.css.map */
